export const getDefaultArea = ({ index, calculatorType, lineItemName }) => {
  return {
    key: `${index}`,
    name: lineItemName ? `${lineItemName} ${index + 1}` : '',
    length: '',
    width: '',
    depth: calculatorType === 'Volume' ? '3' : '',
    squareFootage: {
      value: '',
      changed: false
    }
  };
};